// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__ofQvB","selectSelect":"style_selectSelect__1+P7e"};